var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedCurrency, FormattedMessage } from "@irati/utils/lang";
import { RouterLink as RouterLinkBase } from "@irati/ui/src/Link";
import authentication from "@irati/auth";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { greys } from "@irati/ui/src/global/colors";
import { minWidthMedia } from "@irati/ui/src/global/media";
import Flex from "@irati/ui/src/Flex";
var PendingDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n\n  ", "\n"], ["\n  color: ", ";\n  font-size: 14px;\n\n  ",
    "\n"])), greys.medium, minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: inherit;\n  "], ["\n    font-size: inherit;\n  "]))));
var RouterLink = styled(RouterLinkBase)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: auto !important;\n"], ["\n  height: auto !important;\n"])));
var WalletLink = /** @class */ (function (_super) {
    __extends(WalletLink, _super);
    function WalletLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WalletLink.prototype.render = function () {
        var _a = this.props, id = _a.id, onClick = _a.onClick, useIcon = _a.useIcon, text = _a.text, to = _a.to, wallet = _a.wallet, tenantName = _a.tenantName;
        var availableBalance = wallet.availableBalance, currency = wallet.currency, scheduledInBalance = wallet.scheduledInBalance;
        var WALLET = this.context.apps.WALLET;
        var walletCurrency = currency || authentication.defaultUserCurrency();
        return (React.createElement(RouterLink, { app: WALLET, id: id, onClick: onClick, to: to, plain: true },
            React.createElement("div", null,
                useIcon && (React.createElement(Flex, { alignItems: "center" },
                    React.createElement(Icon, { icon: IconTypes.wallet, size: 24, marginRight: true }),
                    tenantName ? React.createElement(FormattedMessage, { id: text, values: { tenantName: tenantName } }) : React.createElement(FormattedMessage, { id: text }),
                    "\u00A0|\u00A0",
                    React.createElement(FormattedCurrency, { isCents: false, currency: walletCurrency, value: availableBalance }))),
                !useIcon && (React.createElement(React.Fragment, null,
                    tenantName ? React.createElement(FormattedMessage, { id: text, values: { tenantName: tenantName } }) : React.createElement(FormattedMessage, { id: text }),
                    "\u00A0|\u00A0",
                    React.createElement(FormattedCurrency, { isCents: false, currency: walletCurrency, value: availableBalance }))),
                scheduledInBalance > 0 && (React.createElement(PendingDiv, null,
                    React.createElement(FormattedMessage, { id: "platform.wallet.menu.pending", values: {
                            pendingBalance: React.createElement(FormattedCurrency, { isCents: false, value: scheduledInBalance, currency: walletCurrency })
                        } }))))));
    };
    WalletLink.defaultProps = {
        wallet: {
            availableBalance: 0,
            currency: authentication.defaultUserCurrency()
        }
    };
    WalletLink.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return WalletLink;
}(PureComponent));
export default WalletLink;
var templateObject_1, templateObject_2, templateObject_3;
